import { Habit, TaskFilterOptions, TaskType, WeekDays } from '@griply/types';

import { processScheduleTasks } from './process-schedule-tasks';

export type FilterHabitsOptions = {
  habits: Habit[];
  filters: TaskFilterOptions[];
  weekStartsOn: WeekDays;
  today: Date;
};

export const filterHabits = ({
  habits,
  filters,
  weekStartsOn,
  today,
}: FilterHabitsOptions): Habit[] => {
  if (!habits.length || !filters.length) {
    return habits;
  }

  const hasDeadlineDeadlineFilters = filters.every(
    (f) =>
      f.deadlineDeadlineStartDate ||
      f.deadlineDeadlineEndDate ||
      f.hasDeadlineDeadline,
  );

  if (hasDeadlineDeadlineFilters) {
    return [];
  }

  // Check if ALL filter sets exclude habits. If even one allows habits, we proceed.
  const allowsHabits = filters.some(
    (f) => !f.types?.length || f.types.includes(TaskType.Habit),
  );

  if (!allowsHabits) {
    return [];
  }

  const wantsDeleted = filters.some((f) => f.deleted);
  const wantsLive = filters.some((f) => !f.deleted);

  // filter out the habits with `hideOnTodo` when those should be excluded
  const _habits = habits.filter((habit) => {
    if (habit.deletedAt ? !wantsDeleted : !wantsLive) {
      return false;
    }
    if (habit.archivedAt || habit.frozenAt) {
      return false;
    }
    if (filters.some((f) => f.excludeHiddenTodoHabits)) {
      return !habit.hideOnTodo;
    }
    return true;
  });

  return processScheduleTasks(_habits, filters, {
    weekStartsOn,
    today,
  }) as Habit[];
};
